import React, { Component } from 'react';
import asyncWrapper from '../../../../../../shared/javascripts/hocs/asyncWrapper'
import Loading from '../../../../../../shared/javascripts/components/Loading'
import { Chart } from "react-google-charts";

import UserProgressApi from '../../../api/UserProgressApi'

class CategoryMistakes extends Component {
  constructor(props) {
    super(props)
    this.state = {data: {}}
  }

  componentDidMount() {
    UserProgressApi.fetchCategoryScores(this.props.user.id)
      .then(this.props.handleErrors)
      .then(response => {
        this.setState({data: response},
          ()=>this.props.setLoading()
        )
      }).catch(error => console.log(error))
  }
  render() {
    if(this.props.loading) {return <Loading />}
    let chartData = this.state.data;

    return (
      <div className="row">
        {
          Object.keys(chartData).map((weekName, key) => {
            let data = chartData[weekName]
            return(
              <div key={`${key}-${weekName}`} className="col-md-3">
                <Chart
                  chartType="ColumnChart"
                  data={data}
                  options={{
                    title: (key===0 ? 'Category Wise Mistakes (Last 4 Weeks)': ''),
                    isStacked: true,
                    "vAxis": {
                      "title": "Percentages(%)",
                      minValue: 0,
                    },
                    "hAxis": {"title": weekName},
                  }}
                />
              </div>
            )
          })
        }
      </div>
    )
  }
}

export default asyncWrapper(CategoryMistakes)


// WEBPACK FOOTER //
// ./src/reports/google_play/javascripts/components/User/Scores/CategoryMistakes.jsx